import script from "./HelpdeskPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./HelpdeskPage.vue?vue&type=script&lang=ts&setup=true"

import "./HelpdeskPage.vue?vue&type=style&index=0&id=3d24bb9b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d24bb9b"]])

export default __exports__